import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useOrderFinancialRowTypesDict = () => {
    const {t} = useTwinTranslation()
    const financialRowTypesDict: TwinDictionary = {
        0: { name: t('discount', 'Descuento') },
        1: { name: t('discountWithCosts', 'Descuento con Costes') },
        2: { name: t('recharge', 'Recargo') },
        3: { name: t('rechargeWithCosts', 'Recargo con Costes') },
        4: { name: t('rechargeFinancial', 'Recargo Financiero') }
    }
    return financialRowTypesDict
}

export default useOrderFinancialRowTypesDict